export { default } from './TabGroupBancoDoAuto';
